export default __webpack_public_path__ + "static/media/avatar_mei_ling5.44698085.mp3";